export const Conditions = {
  Equal: 'Equal',
  NotEqual: 'NotEqual',
  GreaterThan: 'GreaterThan',
  GreaterThanOrEqual: 'GreaterThanOrEqual',
  LessThan: 'LessThan',
  LessThanOrEqual: 'LessThanOrEqual',
  Contains: 'Contains',
  ContainsAll: 'ContainsAll',
} as const;

export type ConditionType = (typeof Conditions)[keyof typeof Conditions];

export const Users = {
  Admin: 'admin',
  Administrator: 'administrator',
  AdminPassword: '1nf0supp0rt',
};

export type UsersType = (typeof Users)[keyof typeof Users];

export const MWAccountGroups = {
  AlterCode: 'AlterCode',
};

export type MWAccountGroupsType = (typeof MWAccountGroups)[keyof typeof MWAccountGroups];

export const MWEntities = {
  Materials: 'Materials',
};

export type MWEntityType = (typeof MWEntities)[keyof typeof MWEntities];

export const MWDataTypes = {
  INT: 'INT',
  INTN: 'INTN',
  INTN0: 'INTN0',
  FLOAT: 'FLOAT',
  FLOATN: 'FLOATN',
  FLOATN0: 'FLOATN0',
  STRING: 'STRING',
  STRINGN: 'STRINGN',
  TEXT: 'TEXT',
  TEXTN: 'TEXTN',
  BOOLEAN: 'BOOLEAN',
  BOOLEANN: 'BOOLEANN',
  LIST_SINGLE: 'LIST_SINGLE',
  LIST_MULTIPLE: 'LIST_MULTIPLE',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  TIME: 'TIME',
  IMAGE: 'IMAGE',
} as const;

export type MWDataType = (typeof MWDataTypes)[keyof typeof MWDataTypes];

export const MWParams = {
  MULTICOMPANY: 'MULTICOMPANY',
  MULTICOMPANYSITES: 'MULTICOMPANYSITES',
  MULTIWRHOUSE: 'MULTIWRHOUSE',
  USEWRSECTOR: 'USEWRSECTOR',
  USEWRCORRIDOR: 'USEWRCORRIDOR',
  USEWRSHELF: 'USEWRSHELF',
  INVENTORYSECONDPASS: 'INVENTORYSECONDPASS',
  ACTIONONDIFFBETWEEN2PASSES: 'ACTIONONDIFFBETWEEN2PASSES',
  USEUINIT2: 'USEUINIT2',
  USEUINIT3: 'USEUINIT3',
  USEKG: 'USEKG',
  USEDIM1: 'USEDIM1',
  USEDIM1DIM2: 'USEDIM1DIM2',
  ASSIGNORSEGMENTATION: 'ASSIGNORSEGMENTATION',
  CHECKIFEXISTMATATERIALSINSEGMENTS: 'CHECKIFEXISTMATATERIALSINSEGMENTS',
  USEBRANDS: 'USEBRANDS',
  USEGROUPS: 'USEGROUPS',
  CHECKDOUBLESEGMENTSASSINGMENTS: 'CHECKDOUBLESEGMENTSASSINGMENTS',
  ADDQUANTITYPERHIT: 'ADDQUANTITYPERHIT',
  FOCUSTOQUANTITYAFTERSEARCH: 'FOCUSTOQUANTITYAFTERSEARCH',
  NUMBER_LASTLINES__INVENTORY: 'NUMBER_LASTLINES__INVENTORY',
  EDITQUANTITIES: 'EDITQUANTITIES',
  MOBILEDATAMODE: 'MOBILEDATAMODE',
  MATERIALSTANDARDPOSITIONMODE: 'MATERIALSTANDARDPOSITIONMODE',
  ADDPACKADDITIONALFIELDS: 'ADDPACKADDITIONALFIELDS',
  SERIALNUMBER: 'SERIALNUMBER',
  ALLOWMOBILEPRINTING: 'ALLOWMOBILEPRINTING',
  LABELPRINTINGSINGLECOPY: 'LABELPRINTINGSINGLECOPY',
  USECREDITCONTROL: 'USECREDITCONTROL',
  USEAVAILABLE_PIORDERS: 'USEAVAILABLE_PIORDERS',
  USEASSIGNMENT_PICKING_RECEIVES: 'USEASSIGNMENT_PICKING_RECEIVES',
  USEAPPROVAL_PARTIALEXEC_ORDERS: 'USEAPPROVAL_PARTIALEXEC_ORDERS',
  CHECKWRH_BALANCE: 'CHECKWRH_BALANCE',
  USECOMMAND_TOEXPORT: 'USECOMMAND_TOEXPORT',
  UPDATERESERVE_QUANTITY: 'UPDATERESERVE_QUANTITY',
  UPDATEEXPECTED_QUANTITY: 'UPDATEEXPECTED_QUANTITY',
  USESEQUENCIES: 'USESEQUENCIES',
  INSTALLATION: 'INSTALLATION',
  STANDARDJOBSROOTGROUP: 'STANDARDJOBSROOTGROUP',
  QUANTITYMAXVALUE: 'QUANTITYMAXVALUE',
  PIORDER_ADD_SKU: 'PIORDER_ADD_SKU',
  FSDECIMALPOINTSNUMBER: 'FSDECIMALPOINTSNUMBER',
  OMITABSENTGROUPQUESTIONNAIRES: 'OMITABSENTGROUPQUESTIONNAIRES',
  TRIVIAL_FETCH_PAGE_SIZE: 'TRIVIAL_FETCH_PAGE_SIZE',
  HEAVY_FETCH_PAGE_SIZE: 'HEAVY_FETCH_PAGE_SIZE',
  UPLOAD_PAGE_SIZE: 'UPLOAD_PAGE_SIZE',
  TRIVIAL_TASKS_TIMEOUT: 'TRIVIAL_TASKS_TIMEOUT',
  COMMON_TASKS_TIMEOUT: 'COMMON_TASKS_TIMEOUT',
  HEAVY_DUTY_TASKS_TIMEOUT: 'HEAVY_DUTY_TASKS_TIMEOUT',
  COMPANY_MOTO: 'COMPANY_MOTO',
  COMPUTE_DIGITS: 'COMPUTE_DIGITS',
  DISPLAY_DIGITS: 'DISPLAY_DIGITS',
  ROUND_TYPE: 'ROUND_TYPE',
  REQUIREQUESTIONNAIRESANSWERED: 'REQUIREQUESTIONNAIRESANSWERED',
  MOBILE_DEVICE_ORIENTATION: 'MOBILE_DEVICE_ORIENTATION',
  COMPANY_LOGO: 'COMPANY_LOGO',
  BO_BASE_URL: 'BO_BASE_URL',
  BO_ITEM_BALANCE_URL: 'BO_ITEM_BALANCE_URL',
  BO_ITEM_RECENT_TRANSACTION_URL: 'BO_ITEM_RECENT_TRANSACTION_URL',
  BO_CUSTOMER_FINANCIAL_INFO_DETAILED_URL: 'BO_CUSTOMER_FINANCIAL_INFO_DETAILED_URL',
  BO_FETCH_SOURCE: 'BO_FETCH_SOURCE',
  DAYS_TO_DELIVERY: 'DAYS_TO_DELIVERY',
  TRADERS_FULL_ONLINE_SEARCH: 'TRADERS_FULL_ONLINE_SEARCH',
  ESA_BASEURL: 'ESA_BASEURL',
  ESA_TAXNO_RESOLVER_URL: 'ESA_TAXNO_RESOLVER_URL',
  AADE_TAXNO_RESOLVER_USERNAME: 'AADE_TAXNO_RESOLVER_USERNAME',
  AADE_TAXNO_RESOLVER_PASSWORD: 'AADE_TAXNO_RESOLVER_PASSWORD',
  BO_GET_HTML_TABS_SQL_FUNCTION: 'BO_GET_HTML_TABS_SQL_FUNCTION',
  DAYS_DEPTH: 'DAYS_DEPTH',
  ESA_SUBSCRIPTION_KEY: 'ESA_SUBSCRIPTION_KEY',
  ESA_USER_ID: 'ESA_USER_ID',
  ESA_HEADER_PROVIDER_TYPE: 'ESA_HEADER_PROVIDER_TYPE',
  ESA_LOGIN_URL: 'ESA_LOGIN_URL',
  ESA_SEND_DOCUMENT_URL: 'ESA_SEND_DOCUMENT_URL',
} as const;

export type MWParamType = (typeof MWParams)[keyof typeof MWParams];

export const LocalStorageKeys = {
  SessionDetails: 'sessionDetails',
  RememberMe: 'rememberMe',
  Username: 'username',
  Password: 'password',
  DbName: 'dbName',
  ServerIP: 'serverIP',
  ServerPort: 'serverPort',
  Protocol: 'protocol',
  SessionID: 'sessionID',
  Language: 'language',
  MwParams: 'mwParams',
  InstallationModules: 'installationModules',
  CompanyLogo: 'companyLogo',
} as const;

export type LocalStorageKeyType = (typeof LocalStorageKeys)[keyof typeof LocalStorageKeys];

export const MWQuestionnaireTypes = {
  Generic: 'Generic',
  ForwardStock: 'ForwardStock',
  MerchandisingStandardAlt: 'MerchandisingStandardAlt',
  Assortment: 'Assortment',
} as const;

export type MWQuestionnaireType = (typeof MWQuestionnaireTypes)[keyof typeof MWQuestionnaireTypes];
